import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { WatchlistProvider } from "@/context/WatchlistContext";
import { TutorialProvider } from "@/context/TutorialContext";
import AppHeader from "@/components/AppHeader";
import TutorialOverlay from "@/components/TutorialOverlay";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Inserzioni from "@/pages/Inserzioni";
import Aste from "@/pages/Aste";
import Opportunita from "@/pages/Opportunita";
import RicercaIdeale from "@/pages/RicercaIdeale";
import AreeSalvate from "@/pages/AreeSalvate";
import NPL from "@/pages/NPL";
import Agenzie from "@/pages/Agenzie";
import Confronto from "@/pages/Confronto";
import Preferiti from "@/pages/Preferiti";
import Mutuo from "@/pages/Mutuo";
import Citta from "@/pages/Citta";
import Impostazioni from "@/pages/Impostazioni";

function Layout({ children }) {
  return (
    <div className="App">
      <AppHeader />
      {children}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <WatchlistProvider>
        <BrowserRouter>
        <TutorialProvider>
        <TutorialOverlay />
        <Routes>
          <Route path="/" element={<Layout><Landing /></Layout>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout><Dashboard /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inserzioni"
            element={
              <ProtectedRoute>
                <Layout><Inserzioni /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/aste"
            element={
              <ProtectedRoute>
                <Layout><Aste /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/opportunita"
            element={
              <ProtectedRoute>
                <Layout><Opportunita /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ricerca"
            element={
              <ProtectedRoute>
                <Layout><RicercaIdeale /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/aree-salvate"
            element={
              <ProtectedRoute>
                <Layout><AreeSalvate /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/npl"
            element={
              <ProtectedRoute>
                <Layout><NPL /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/agenzie"
            element={
              <ProtectedRoute>
                <Layout><Agenzie /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/confronto"
            element={
              <ProtectedRoute>
                <Layout><Confronto /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/preferiti"
            element={
              <ProtectedRoute>
                <Layout><Preferiti /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mutuo"
            element={
              <ProtectedRoute>
                <Layout><Mutuo /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/citta"
            element={
              <ProtectedRoute>
                <Layout><Citta /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/impostazioni"
            element={
              <ProtectedRoute>
                <Layout><Impostazioni /></Layout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </TutorialProvider>
        </BrowserRouter>
      </WatchlistProvider>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}
